<template>
  <div class="product-box">
    <div class="title-box">
      <span class="title">产品信息</span>
    </div>

    <el-form :model="formInline" :disabled="disabled" label-position="top">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="申请产品">
            <el-select
              v-model="productId"
              placeholder="请选择"
              style="width: 100%"
              @change="changeProduct"
              filterable
              :disabled="true"
              remote
            >
              <el-option
                v-for="(item, index) in productList"
                :key="index"
                :label="item.productName"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="贷款类型">
            <el-input v-model="formInline.loanTypeStr" disabled style="width: 100%" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="产品类型">
            <el-input v-model="formInline.productTypeStr" disabled style="width: 100%" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="分销机构">
            <el-input
              :model-value="retailIntoInfoDO.belongTenantName"
              disabled
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script lang="ts" setup>
import { getProductListbpm, getProductListerp } from '@/apis/erp/income'
import { ref, onMounted } from 'vue'
import { loanList } from '@/views/erp/enums'
import { useResource } from '@/hooks/useResource'
const { getMenuId } = useResource()
const BpmProductManageMenuId = getMenuId({ code: 'BpmProductManage' })
const ErpProductManageMenuId = getMenuId({ code: 'ErpProductManage' })

const formInline = ref<Recordable>({})

const props = defineProps({
  id: {
    type: String,
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false
  },
  info: {
    type: Object as PropType<Recordable>,
    default: () => {
      return {}
    }
  },
  comType: {
    type: Number,
    default: 101 // 101 erp   102 bpm
  },
  retailIntoInfoDO: {
    type: Object as PropType<Recordable>,
    default: () => {
      return {}
    }
  }
})

const productDetails = computed(() => {
  return props.info || {}
})
const productList = ref<Recordable>([])

watch(productDetails, val => {
  const item = productList?.value?.find((el: Recordable) => el.id === props.id)
  if (!item) {
    // 如果产品列表没有返回对应的数据，就把详情接口的数据回填
    productList?.value?.push(val)
    console.log(productList.value, val, '进来了')
    changeProduct(props.id, true)
  }
})

onMounted(() => {
  let params = new FormData()
  if (props.comType === 101) {
    getProductListerp(params, { MenuId: ErpProductManageMenuId }).then(res => {
      productList.value =
        res?.map((item: Recordable) => {
          return {
            ...item,
            label: item.productName,
            value: item.id
          }
        }) || []
      productId.value = props.id
      changeProduct(props.id)
    })
  } else {
    getProductListbpm(params, { MenuId: BpmProductManageMenuId }).then(res => {
      productList.value =
        res?.map((item: Recordable) => {
          return {
            ...item,
            label: item.productName,
            value: item.id
          }
        }) || []
      productId.value = props.id
      changeProduct(props.id)
    })
  }
})

const productId = ref('')
const emit = defineEmits(['changeProduct'])

const changeProduct = (val: string, noEmit = false) => {
  const item = productList.value.find((el: Recordable) => el.id === val)
  if (item?.id) {
    formInline.value = item
    if (item.loanType === 1) formInline.value.loanTypeStr = '个人贷'
    else formInline.value.loanTypeStr = '企业贷'
    loanList.forEach(data => {
      if (item.productType === data.value) formInline.value.productTypeStr = data.label
    })
  } else {
    formInline.value = {
      id: val
    }
  }
  if (noEmit) return
  emit('changeProduct', formInline.value)
}
</script>

<style scoped lang="scss">
.title-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 38px;

  .title {
    font-size: 14px;
    color: #333333;
    font-weight: 700;
    display: inline-block;
    border-left: 3px solid #5687ff;
    padding-left: 9px;
  }
}
.product-box {
  margin: 16px 24px;
}
</style>
